import _axios, { AxiosError } from 'axios'
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry'

export const axiosWithRetry = _axios.create({
  withCredentials: true,
})

axiosRetry(axiosWithRetry, {
  retries: 2,
  retryDelay: axiosRetry.exponentialDelay,
  // https://github.com/softonic/axios-retry/issues/138
  // retry on network error or retryable error
  retryCondition: (error: AxiosError) => /Network Error/i.test(error.message) || isNetworkOrIdempotentRequestError(error)
})

export const axios = _axios.create({
  withCredentials: true,
})
